import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task02 } from "../../../../../task/course-04/lesson-05/task-02";

const task: Slide = {
  title: `The mechanical circuit of an oscillator is given below. Calculate its resonance frequency.`,
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/05/task/task-2.svg`,
                },
              },
              styles: {
                padding: "5%",
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
